import { render } from "./CookieDlg.vue?vue&type=template&id=19b272be&scoped=true&ts=true"
import script from "./CookieDlg.vue?vue&type=script&lang=ts"
export * from "./CookieDlg.vue?vue&type=script&lang=ts"

import "./CookieDlg.vue?vue&type=style&index=0&id=19b272be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_typescript@5.9.3__webpack@5.107.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b272be"]])

export default __exports__